import React from "react";

export default function Governance() {
	return (
		<>
			<div className="beratung_cont" id="governance_advisory">
				<h1>Beratung durch unsere Governance Services</h1>
				<h2>DIE Herausforderung in der GRC-Beratung!</h2>
				<p>
					Governance Advisory bezieht sich auf die umfassende Beratung (von der
					Konzeption bis zum modus operandi) zu den Managementsystemen
					Risikomanagement, Compliance Management und Internes Kontrollsystem
					sowie deren exzellente Verzahnung und zieht sich aus dem Operativen in
					der Organisation bis hin zum Aufsichtsrat in seiner Rolle als
					Beratungs- und Überwachungsorgan.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Erfahrung aus einer Vielzahl erfolgreicher Projekte mit
						Organisationen unterschiedlicher Größe und Komplexität
					</li>
					<li>
						Neben der Durchführung von Projekten steht Lehre, Forschung und das
						Publizieren bei uns regelmäßig auf der Agenda. So stellen wir die
						nötige fachliche Fitness sicher.
					</li>
					<li>
						Aktuelle Entwicklungen wie z.B. zur Nachhaltigkeit werden adäquat
						berücksichtigt.
					</li>
				</ul>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
